import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../login/login.service';
import {ProfileService} from './profile.service';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'afm-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  user : any;
  
  constructor(public loginService:LoginService,public profileService : ProfileService,private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
      var loggedUser = this.loginService.getLoggedUser();
      this.user = {};
      this.user.login = loggedUser.login;
      this.user.name = loggedUser.name;
      this.user.email = loggedUser.email;
  }
  
  editProfile(){
    this.profileService.saveProfile(this.user);
  }
  
  editPassWord(){
      this.confirmationService.confirm({
            message: 'Are you sure that you want to perform this action?',
            accept: () => {
                this.profileService.changePassword(this.user);
            }
        });
  }
  reset(){
    this.ngOnInit();
  }
  

}
